import Features from './components/Features';
import Nutrition from './components/Nutrition';
import PaymentApi from './components/Payment';
import Subscriptions from './components/Subscriptions';
import UserApi from './components/User';
import Workouts from './components/Workouts';

function ApiInstance() {
    const user = new UserApi();
    const subscriptions = new Subscriptions();
    const workouts = new Workouts();
    const payments = new PaymentApi();
    const nutrition = new Nutrition();
    const features = new Features();

    return {
        user,
        subscriptions,
        workouts,
        payments,
        nutrition,
        features,
    };
}

export default ApiInstance();
